import Layout from '@/layout/default'
import auth from './middleware/auth'
import role from './middleware/role'

export default [
  {
    path: '/project-evaluations',
    component: Layout,
    redirect: '/project-evaluations/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/project-evaluation'),
        name: 'project-evaluations.index',
        meta: {
          title: 'Project evaluation',
          middleware: [auth, role],
          roles: ['admin']
        }
      }
    ]
  },
  {
    path: '/users',
    component: Layout,
    name: 'users',
    redirect: '/users/index',
    children: [
      {
        path: 'index',
        component: () => import('@views/user'),
        name: 'users.index',
        meta: {
          title: 'Users',
          middleware: [auth, role],
          roles: ['admin']
        }
      },
      {
        path: 'create',
        component: () => import('@views/user/create'),
        name: 'users.create',
        meta: {
          title: 'Create user',
          middleware: [auth, role],
          roles: ['admin']
        }
      },
      {
        path: ':id/edit',
        component: () => import('@views/user/edit'),
        name: 'users.edit',
        meta: {
          title: 'Edit user',
          middleware: [auth, role],
          roles: ['admin']
        }
      }
    ]
  },
  {
    path: '/reports',
    component: Layout,
    name: 'reports',
    redirect: '/reports/tasks',
    children: [
      {
        path: 'tasks',
        component: () => import('@views/report/tasks'),
        name: 'reports.tasks',
        meta: {
          title: 'Report tasks',
          middleware: [auth, role],
          roles: ['admin']
        }
      },
      {
        path: 'task-records',
        component: () => import('@views/report/task-records'),
        name: 'reports.task-records',
        meta: {
          title: 'Report task records',
          middleware: [auth, role],
          roles: ['admin']
        }
      },
      {
        path: 'points',
        component: () => import('@views/report/points'),
        name: 'reports.points',
        meta: {
          title: 'Report points',
          middleware: [auth, role],
          roles: ['admin']
        }
      }
    ]
  }
]
